import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { getDetailDocument } from "../detailsDocument/index";
import { getDocumentsWithSearch } from "../documentsWithSearch/index";

import { APP_PDC_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";

export const renameDocumentsConstants = {
  RENAME_DOCUMENT_START: "RENAME_DOCUMENT_START",
  RENAME_DOCUMENT_SUCCESS: "RENAME_DOCUMENT_SUCCESS",
  RENAME_DOCUMENT_ERROR: "RENAME_DOCUMENT_ERROR"
};

export function editDocumentFilename(documentId, newFilename) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantId = main.accountantSelected;
    const itemId = main.companySelected;

    let request = {
      method: "patch",
      url: `${APP_PDC_URL}/v2/documents/${documentId}/rename?newFileName=${newFilename}&itemId=${itemId}&accountantId=${accountantId}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: renameDocumentsConstants.RENAME_DOCUMENT_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: renameDocumentsConstants.RENAME_DOCUMENT_SUCCESS,
              payload: result.data
            });
            dispatch(getDetailDocument(documentId));
            dispatch(getDocumentsWithSearch(null, ""));
            resolve(result.data);
          } else {
            dispatch({
              type: renameDocumentsConstants.RENAME_DOCUMENT_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: renameDocumentsConstants.RENAME_DOCUMENT_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
